import styled from 'styled-components'
import variablesApplicationConfig from '../../../variables'

export const ContainerSocialHeader = styled.div`
  width: 100%;
  background-color: white;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

export const ContainerSocialHeaderTop = styled.div`
  width: 100%;
  height: 40px;

  background-color: var(--primary-color);

  display: flex;
  align-items: center;
  justify-content: center;

  .inner-header-top {
    width: 100%;
    max-width: var(--max-width-section);

    display: flex;
    align-items: center;
    justify-content: space-between;

    padding-left: 20px;

    .box-icon-contact {
      display: flex;
      gap: 20px;

      color: rgba(255, 255, 255, 1);
      font-weight: bold;

      font-size: 14px;

      .box-icon-contact-option {
        display: flex;
        gap: 20px;
      }
    }
    .box-icon-social-media {
      display: flex;
      gap: 30px;
      margin-right: 20px;

      svg {
        color: rgba(255, 255, 255, 1);
        cursor: pointer;
      }
    }
  }

  @media (max-width: ${() => variablesApplicationConfig.mobileBreakpoint}px) {
    display: none;
    .inner-header-top {
    }
  }
`

export const ContainerSocialHeaderMenu = styled.div`
  width: 100%;
  max-width: var(--max-width-section);
  height: 100px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  background-color: white;

  padding: 0px 12px;

  border-radius: 40px;

  @media (max-width: ${() => variablesApplicationConfig.desktopBreakpoint}px) {
    height: auto !important;
    margin-top: 0 !important;
    border-radius: 0 !important;
    padding: 30px 20px !important;
  }
`

export const ContainerSocialHeaderMenuLogo = styled.div`
  height: 60px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 30px;

  cursor: pointer;

  img {
    height: 60px;
    width: 60px;
    margin-bottom: 2px;

    cursor: pointer;
  }

  h2 {
    display: block;
    margin-left: 10px;
  }
`

export const ContainerSocialHeaderMenuOptionsBox = styled.nav`
  display: flex;
  gap: 20px;
  @media (max-width: ${() => variablesApplicationConfig.tabletBreakpoint}px) {
    display: none;
  }
`

export const ContainerSocialHeaderMenuOptions = styled.div`
  display: flex;
  gap: 3px;

  align-items: flex-end;
  justify-content: center;

  cursor: pointer;

  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.8);

  transition: 0.2s all ease-in-out;

  &:hover {
    color: black;
  }

  svg {
    font-size: 16px;
    transition: 0.2s all ease-in-out;
  }
`

export const ContainerSocialHeaderMenuAction = styled.div`
  height: 60px;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: var(--primary-color);

  border-radius: 30px;

  padding: 0px 30px 1px;

  color: var(--primary-contrast-color);
  font-weight: 600;

  cursor: pointer;

  @media (max-width: ${() => variablesApplicationConfig.tabletBreakpoint}px) {
    display: none;
  }
`

export const ContainerSocialHeaderMenuActionMobile = styled.div`
  margin-right: 30px;
  cursor: pointer;

  display: none;

  svg {
    font-size: 32px;
  }

  @media (max-width: ${() => variablesApplicationConfig.tabletBreakpoint}px) {
    display: flex !important;
  }
`
